import Api from "clients/helpers/api";

import { UserProfileApiResponse } from "./types";

export async function getUserProfile(
  userProfileId: string
): Promise<UserProfileApiResponse> {
  return Api.get(`/user-profiles/${userProfileId}`);
}
